import WeatherCard from './weather-card'
export default WeatherCard
